import type { CameraTamper, TamperSignal } from './api'

const LABELS: Record<TamperSignal, string> = {
  obscured: 'Lens obscured',
  // Not "moved": a partly covered lens reads exactly like a move, and nothing
  // measured tells them apart (#119), so this says what is known.
  moved: 'View lost',
}

/**
 * What a tampered camera's marker says. Named by signal because the two need
 * different fixes; a server too old to report signals still gets a marker,
 * since being tampered without saying how beats saying nothing.
 */
export function tamperLabel(t: CameraTamper): string {
  const names = (t.signals ?? []).map((s) => LABELS[s] ?? 'Tampered')
  return names.length ? [...new Set(names)].join(' · ') : 'Tampered'
}
